/* Publish by EComposer at 2026-10-29 13:40:44*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0p2ppjbp0hd"]=  window.__ectimmers["ecom-0p2ppjbp0hd"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-0p2ppjbp0hd"]["a0o53wcra"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-0p2ppjbp0hd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0p2ppjbp0hd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w3pdzhmxhik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w3pdzhmxhik', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7exdqfnlprv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7exdqfnlprv', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n4zsmc881c9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n4zsmc881c9', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2l69xaflag1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2l69xaflag1', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-69f0eelb1vs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-69f0eelb1vs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wbr0pv0b8a8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wbr0pv0b8a8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ftpkfzxz6ch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ftpkfzxz6ch', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1cytg446kf5h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1cytg446kf5h', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-myv6dipf4qf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-myv6dipf4qf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z6boxwrgvt8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z6boxwrgvt8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lvl9dqi477r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lvl9dqi477r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mvinee8ipz8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mvinee8ipz8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zmzunt5d48').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zmzunt5d48', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3n1fgcl4co').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3n1fgcl4co', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w58rptgyj5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w58rptgyj5', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yittq7qft2l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yittq7qft2l', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aa4sd7y4r47').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aa4sd7y4r47', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5in4j5ynsh2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5in4j5ynsh2', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hy8mqo8yv3v"]=  window.__ectimmers["ecom-hy8mqo8yv3v"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-hy8mqo8yv3v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hy8mqo8yv3v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ngqn9gp8zm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ngqn9gp8zm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mih25nabj6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mih25nabj6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yutsgq6o22i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yutsgq6o22i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tsolawd70m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tsolawd70m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a1emmil99h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a1emmil99h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l08hlrrybyc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l08hlrrybyc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m6sa75fwtzk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6sa75fwtzk', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ty0o76rrii"]=  window.__ectimmers["ecom-ty0o76rrii"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-ty0o76rrii"]["g6i7tzo22"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ty0o76rrii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ty0o76rrii', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wfzhw0ucih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wfzhw0ucih', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ein3h6jf84').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ein3h6jf84', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bz1hy50wvdm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bz1hy50wvdm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-59aseczh2oo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-59aseczh2oo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-woqbdpaq39l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-woqbdpaq39l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bhr52i7klbm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bhr52i7klbm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-45du3je88za').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-45du3je88za', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7u2gv81bgij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7u2gv81bgij', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z3xqnuarhup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z3xqnuarhup', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mqvhekbo1jb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mqvhekbo1jb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f2ye8qhhq3r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2ye8qhhq3r', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}